
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import Vue from 'vue'
import OnlineService from '@/services/OnlineService'
import { RootState } from '@/store'

export default Vue.extend({
  name: 'Login',
  created () {
    this.$store.dispatch('clearLogin')
    this.$store.commit('isLoading', true)
    this.$store.commit('isLoadingForce', true)
    const companyId = process.env.VUE_APP_COMPANY_ID
    OnlineService.login(companyId).then(data => {
      window.location.href = data.loginUrl
    })
  },
  beforeRouteLeave (to, from, next) {
    if ((this.$store.state as RootState).loginError) {
      this.$store.commit('loginError', false)
    }
    next()
  }
})
